module.exports = __webpack_public_path__ + "static/keyboard-f00dfe8ee9aa4eb4eef2929e84528d48.jpg";